import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue";
var _hoisted_1 = { class: "layout flexRow" };
var _hoisted_2 = { class: "pgFlex flexColumn layout_main" };
var _hoisted_3 = { class: "music_play" };
import { reactive, onMounted, onUnmounted, computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import emitter from '../../utils/eventBus';
import loginView from '../login/login.vue';
import musicChat from '../subview/music/music_chat/music_chat.vue';
import tabbarView from './components/tabbar.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup: function (__props) {
        var route = useRoute();
        // 显示播放器
        var showPlay = ref(false);
        var musicChatInfo = ref();
        var playMusic = function (value) {
            showPlay.value = true;
            musicChatInfo.value = value;
        };
        onMounted(function () {
            // 关闭音乐播放弹窗
            emitter.on('closeMusic', function () {
                showPlay.value = false;
                musicChatInfo.value = '';
            });
            emitter.on('playMusic', function (e) {
                playMusic(e);
            });
            var androidBride = window.androidBride;
            if (androidBride) {
                androidBride.setMacInfo('');
            }
            window.setMacInfo = function (event) {
                console.log('获取到的mac地址', event);
                localStorage.setItem('getMacInfo', event);
            };
        });
        onUnmounted(function () {
            emitter.off('closeMusic');
            emitter.off('playMusic');
        });
        /**
         * @导航栏
         */
        // 判断是否显示底部tabbar
        var isTabbar = computed(function () {
            return tabbarList.findIndex(function (el) { return route.path === el.route || route.path === el.other; }) !== -1;
        });
        // 导航栏高度
        var tabbarHeight = computed(function () {
            return isTabbar.value ? '70px' : 0;
        });
        // 列表
        var tabbarList = reactive([
            {
                name: '首页',
                route: '/new-chat',
                other: '/deepseek',
                icon: require('@/assets/images/tabbar/home.png'),
                iconActive: require('@/assets/images/tabbar/home_a.png'),
            },
            {
                name: '智能体',
                route: '/intelligence_list',
                icon: require('@/assets/images/tabbar/znt.png'),
                iconActive: require('@/assets/images/tabbar/znt_a.png'),
            },
            {
                name: 'AI绘画',
                route: '/drawing',
                icon: require('@/assets/images/tabbar/huihua.png'),
                iconActive: require('@/assets/images/tabbar/huihua_a.png'),
            },
            {
                name: 'AI会议',
                route: '/meeting/introduce',
                icon: require('@/assets/images/tabbar/huiyi.png'),
                iconActive: require('@/assets/images/tabbar/huiyi_a.png'),
            },
            {
                name: '我的',
                route: '/mine',
                icon: require('@/assets/images/tabbar/mine.png'),
                iconActive: require('@/assets/images/tabbar/mine_a.png'),
                isNew: true
            }
        ]);
        return function (_ctx, _cache) {
            var _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "main flexColumn pgFlex",
                        style: _normalizeStyle({ height: "calc(100% - ".concat(tabbarHeight.value, ")") })
                    }, [
                        _createVNode(_component_router_view)
                    ], 4),
                    (isTabbar.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "tabbar flexColumn",
                            style: _normalizeStyle({ height: tabbarHeight.value })
                        }, [
                            _createVNode(tabbarView, { lists: tabbarList }, null, 8, ["lists"])
                        ], 4))
                        : _createCommentVNode("", true),
                    _createVNode(_Transition, { name: "el-fade-in-linear" }, {
                        default: _withCtx(function () { return [
                            _withDirectives(_createElementVNode("div", _hoisted_3, [
                                _createVNode(musicChat, _normalizeProps(_guardReactiveProps(musicChatInfo.value)), null, 16)
                            ], 512), [
                                [_vShow, showPlay.value]
                            ])
                        ]; }),
                        _: 1
                    })
                ]),
                _createVNode(loginView)
            ]));
        };
    }
});
